import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-monitoreo-subtipo-heatmap',
  templateUrl: './monitoreo-subtipo-heatmap.component.html',
  styleUrls: ['./monitoreo-subtipo-heatmap.component.scss']
})
export class MonitoreoSubtipoHeatmapComponent {

  @Input() title: string = '';
  @Input() loading: boolean = false;
  @Input() mapData: any = {};
  @Input() nombres: string[] = [];
  @Input() horasColumnas: number[] = [];
  @Input() noDataMessage: string = 'No hay datos disponibles.';

  getValue(nombre: string, hora: number): number {
    return this.mapData[`${nombre}_${hora}`] || 0;
  }

  getRowTotal(nombre: string): number {
    let total = 0;
    for (const h of this.horasColumnas) {
      total += this.getValue(nombre, h);
    }
    return total;
  }

  getColTotal(hora: number): number {
    let total = 0;
    for (const n of this.nombres) {
      total += this.getValue(n, hora);
    }
    return total;
  }

  getGrandTotal(): number {
    let total = 0;
    for (const n of this.nombres) {
      for (const h of this.horasColumnas) {
        total += this.getValue(n, h);
      }
    }
    return total;
  }

  getCellClass(value: number): string {
    if (!value || value === 0) return '';
    let max = 0;
    for (const key in this.mapData) {
      if (this.mapData[key] > max) max = this.mapData[key];
    }
    if (max === 0) return '';
    const ratio = value / max;
    if (ratio >= 0.75) return 'heat-high';
    if (ratio >= 0.4) return 'heat-medium';
    return 'heat-low';
  }
}
